'use client';
import {memo} from 'react';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import styles from './message-content.module.css';

/** Readable results without executing HTML or loading remote images. */
export default memo(function MessageContent({text}:{text:string}) {
  return <div className={styles.content}><Markdown skipHtml remarkPlugins={[remarkGfm]} components={{
    img:({alt})=><span>{alt||''}</span>,
    a:({href,children})=>href&&/^https?:\/\//i.test(href)?<a href={href} target="_blank" rel="noopener noreferrer">{children}</a>:<span>{children}</span>,
    table:({children})=><div className={styles.table}><table>{children}</table></div>,
  }}>{text}</Markdown></div>;
});
